"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreThemes = require("@vfuk/core-themes");
var _coreLoadingSpinner = _interopRequireDefault(require("@vfuk/core-loading-spinner"));
var _IconButton = _interopRequireDefault(require("./themes/IconButton.theme"));
var Styled = _interopRequireWildcard(require("./styles/IconButton.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconButton = function IconButton(_ref) {
  var _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'square' : _ref$shape,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 6 : _ref$size,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$htmlAttributes = _ref.htmlAttributes,
    htmlAttributes = _ref$htmlAttributes === void 0 ? {} : _ref$htmlAttributes,
    dataAttributes = _ref.dataAttributes,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    localTheme = _ref.localTheme,
    state = _ref.state,
    loading = _ref.loading,
    href = _ref.href,
    inverse = _ref.inverse,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    srText = _ref.srText,
    id = _ref.id,
    customRouterProps = _ref.customRouterProps,
    icon = _ref.icon;
  var componentName = 'IconButton';
  var iconButtonTheme = (0, _coreThemes.useLocalTheme)(componentName, _IconButton["default"], localTheme);
  var localThemeAppearance = iconButtonTheme.appearance[appearance];
  if (inverse) {
    localThemeAppearance = localThemeAppearance.inverse;
  }
  var _localThemeAppearance = localThemeAppearance,
    loadingSpinnerAppearance = _localThemeAppearance.loadingSpinnerAppearance,
    inverseIcon = _localThemeAppearance.inverseIcon;
  var isDisabledOrLoading = state === 'disabled' || loading;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconButton, {
    appearance: appearance,
    target: htmlAttributes.target,
    type: htmlAttributes.type,
    componentName: componentName,
    dataAttributes: dataAttributes,
    size: size,
    shape: shape,
    inverse: inverse,
    state: state,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    disabled: isDisabledOrLoading,
    label: srText,
    href: !isDisabledOrLoading ? href : undefined,
    id: id,
    customRouterProps: customRouterProps,
    iconButtonTheme: iconButtonTheme,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    localTheme: iconButtonTheme
  }, loading ? /*#__PURE__*/_react["default"].createElement(Styled.LoadingIcon, null, /*#__PURE__*/_react["default"].createElement(_coreLoadingSpinner["default"], {
    appearance: loadingSpinnerAppearance,
    inverse: inverseIcon,
    size: iconButtonTheme.size[size].loadingSpinnerSize,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'loading-spinner')
  })) : /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: icon.name,
    size: iconButtonTheme.size[size].iconSize,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, icon.name)
  }));
};
IconButton.displayName = "IconButton";
var _default = IconButton;
exports["default"] = _default;
//# sourceMappingURL=IconButton.js.map